import React from 'react';
import classNames, { Argument } from 'classnames';
import { FormattedMessage } from 'react-intl';

import { useSelector } from 'hooks';

import { arePreApprovedPricesHidden } from 'modules/selfServices/selectors';
import { usePriceFormatter } from 'utils/PriceFormatter/usePriceFormatter';
import InclTaxLabel from 'components/ui/InclTaxLabel';

type TotalLineProps = {
  title: React.ReactNode,
  price: number,
  showHiddenPriceWarning?: boolean,
  showInclTax?: boolean,
  className?: Argument
};

const TotalLine: React.FC<TotalLineProps> = (
  { title, price, showHiddenPriceWarning, showInclTax, className },
) => {
  const hidePreApprovedWorksPrices = useSelector(arePreApprovedPricesHidden);
  const priceFormatter = usePriceFormatter();

  const showWarning = showHiddenPriceWarning && hidePreApprovedWorksPrices;

  return (
    <div className={classNames('flex justify-between items-center text-lowest text-xs font-medium pl-2', className)}>
      <div>{title}</div>
      {showWarning && <FormattedMessage id="basket.total.toBeConfirmed" defaultMessage="To be confirmed" />}
      {!showWarning && !showInclTax && priceFormatter(price)}
      {!showWarning && showInclTax && (
        <div className="flex flex-col items-end">
          <span>{priceFormatter(price)}</span>
          <InclTaxLabel />
        </div>
      )}
    </div>
  );
};

export default TotalLine;
